import { render } from "./PRegionalGroups.vue?vue&type=template&id=d2a35e74&scoped=true"
import script from "./PRegionalGroups.vue?vue&type=script&lang=js"
export * from "./PRegionalGroups.vue?vue&type=script&lang=js"

import "./PRegionalGroups.vue?vue&type=style&index=0&id=d2a35e74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a35e74"]])

export default __exports__